import "./styles.scss";

import { useTranslation } from "react-i18next";

import aiIcon from "../../../assets/images/ai-icon.png";

function ButtonStudyWithAI({ setActiveTab }) {
  const { t } = useTranslation();

  return (
    <div className="contentButtonStudyWithAI">
      <h4 className="title">{t("AI_PRACTICE_TITLE")}</h4>

      <div className="content">
        <img src={aiIcon} className="photo" alt="AI Icon" />

        <div>
          <p className="description">{t("AI_PRACTICE_DESCRIPTION")}</p>

          <button className="generateExercisesButton" onClick={() => setActiveTab("AI_PRACTICE")}>
            {t("AI_PRACTICE_GENERATE")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ButtonStudyWithAI;
